module.exports = __webpack_public_path__ + "assets/img/3.22a4ffde.png";